import { RatesErrorProvider } from "@platform/btx-rates";
import { useCallback, type ReactElement, type ReactNode } from "react";

import useToastNotificationService from "../../../../../../../hooks/useToastNotificationService";

export const QuotesRatesErrorProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const { createToastNotification } = useToastNotificationService();
  const handleRatesError = useCallback(
    (message: string) => {
      createToastNotification({ message, severity: "error" });
    },
    [createToastNotification],
  );

  return (
    <RatesErrorProvider value={handleRatesError}>{children}</RatesErrorProvider>
  );
};
